export default "__VITE_ASSET__e1a7db4d__"